'use client';

import Link from 'next/link';

import CompareCarIcon from '@/components/icons/compare-car-icon';
import { handleClick } from '@/components/button/utils/handle-click';
import { Button } from '@/components/ui/button';
import { useCompare } from '@/context/compare';

const CompareButton = () => {
  const { compareVehicleIds } = useCompare();
  const count = compareVehicleIds.length;
  const compareText = `Compare: ${count}`;

  const href = compareVehicleIds.length > 0 ? `/v2/compare?vehicles=${compareVehicleIds.join(',')}` : '/v2/compare';

  return (
    <Button variant="primary" size="sm" className="px-3 [&_svg]:size-5 lg:h-14 lg:px-6 ml-6" asChild>
      <Link href={href} onClick={(e) => handleClick({ event: e, eventText: compareText, eventUrl: href })}>
        <CompareCarIcon aria-hidden />
        <span className="mr-1 sr-only lg:not-sr-only">{compareText}</span>
        <span className="text-lg block lg:hidden" aria-hidden>
          {count}
        </span>
      </Link>
    </Button>
  );
};

export default CompareButton;
